import styled from 'styled-components';
import { Card } from './styles';

export const RosterCard = styled(Card)`
  padding: 32px;
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.6;
  overflow-wrap: anywhere;

  h1 {
    margin: 0 0 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
    color: ${(p) => p.theme.colors.primary500};
    font-size: ${(p) => p.theme.fontSizes.lg};
    line-height: 1.3;
  }

  > p {
    margin-bottom: 24px;
  }

  button {
    min-height: 44px;
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    white-space: normal;
    line-height: 1.4;
  }

  @media (max-width: 639px) {
    padding: 24px 16px;
    button {
      width: 100%;
    }
  }
`;

export const VerificationForm = styled.form`
  display: grid;
  gap: 16px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};
  justify-items: start;

  label {
    width: 100%;
  }
`;

export const RosterList = styled.ol`
  margin: 16px 0 24px;
  padding-left: 28px;
  li {
    padding: 12px 0 12px 8px;
  }
  li + li {
    border-top: 1px solid ${(p) => p.theme.colors.gray100};
  }
`;
